import { Box, Stack } from '@mui/material';
import {useState,useEffect} from 'react'
import { useParams } from 'react-router-dom';
import ChannelCard from './ChannelCard';
import Video from './Video';
import { Fetch } from './Fetch';
const Channel = () => {
  const[response,setresponse]=useState([]);
  const[channelvid,setchannelvid]=useState([]);
  const { id }=useParams();
  useEffect(()=>{
  Fetch(`channels?part=snippet&id=${id}`).then((resp)=>setresponse(resp?.items[0])).catch((err)=>console.log(err));
  Fetch(`search?channelId=${id}&part=snippet&maxResults=50&order=date`).then((vid)=>setchannelvid(vid?.items)).catch((err)=>console.log(err));
  },[id])
  return (
    <Box minHeight="95vh" backgroundColor="white">
     <Box sx={{width:'100%',height:'200px',backgroundColor:'#e0f7fa',zIndex:10}}  />
     <ChannelCard channelDetail={response} />
      <Box>
      <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={5}>
   {
     channelvid.map((e,idx)=>(
       <Video  e={e} idx={idx} key={idx}/>
     ))
}
     </Stack>
      </Box>
    
    </Box>
  )
}

export default Channel